export default class SlaTipoEnum {
    static FinalizacaoTicket = 1
    static PrimeiraRespostaTicket = 2
}
